<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">默认值</nz-form-label>
  <nz-form-control>
    <d-date-picker
      [nzShowTime]="true"
      nzFormat="yyyy-MM-dd HH:mm:ss"
      name="value"
      #nameInput="ngModel"
      [(ngModel)]="config.value"
    ></d-date-picker>
  </nz-form-control>
</nz-form-item>
<!-- 有效值 -->
<nz-form-item>
  <nz-form-label [nzSpan]="6">有效值</nz-form-label>
  <nz-form-control>
    <d-date-picker
      [nzShowTime]="true"
      nzFormat="yyyy-MM-dd HH:mm:ss"
      name="effective"
      #effectiveInput="ngModel"
      [(ngModel)]="config.effective"
    ></d-date-picker>
  </nz-form-control>
</nz-form-item>
